import { Article } from './Article'

export enum ContentType {
  COURSE = 'course',
  SESSION = 'camp',
  CHAPTER = 'chapter',
  SUBCHAPTER = 'subchapter',
  SERIES = 'series',
  MODULE = 'module',
}

export type CourseMeta = {
  courseId: number
  courseSlug: string
  contentType: ContentType
  instructorHeadshotSrc: string
  instructorImgSrc: string
  instructorName: string
  courseTitle: string
  instructorBio: string
  outcomeSlugs: string[]
  trailerId: string
  trailerMediaUuid?: string
}

export type Outcome = {
  name: string
  oneLiner: string
  contents: OutcomeContent[]
  id: number
  slug: string
}

export type OutcomeContent = {
  outcomeSlug: string
  contentType: ContentType
  slug: string
  title: string
  tileImgSrc: string
  durationInSecs?: number
  numberOfLessons?: number
  numberOfVideos?: number
  courseSlug: string
  relevancyScore: number
  chapterSlug?: string
}

export type OutcomeContentRaw = {
  courseSlugs?: string[]
  chapterIds?: number[]
  chapterScores?: number[]
  chapterCourseSlugs?: string[]
  moduleIds?: number[]
  moduleScores?: number[]
  id: number
  name: string
  oneLiner: string
  sessionIds?: number[]
  subchapterIds?: number[]
  subchapterScores?: number[]
  subchapterCourseSlugs?: string[]
}

export type CourseOutcome = {
  name: string
  oneLiner: string
  id: number
  slug: string
}

export type SubcategoryWithOutcome = {
  id: number
  articleSlugs: string[]
  marketingText: string
  name: string
  outcomeSlugs: string[]
  outcomeScores: number[]
  outcomeGroups: number[]
  articles: Article[]
}
